import {createAction} from "@ngrx/store";

export const appInit = createAction(
  '[App] Init'
);
